import React, { createContext, useState, useContext, useMemo } from "react";

const ModalContext = createContext();

const ModalProvider = ({ children }) => {
  const [isModal, setIsModal] = useState(false);
  const [isEditProfileModal, setIsEditProfileModal] = useState(false);
  const [isUploadVideoModal, setIsUploadVideoModal] = useState(false);

  const memoizedContextValue = useMemo(
    () => ({
      setIsModal,
      isModal,
      setIsEditProfileModal,
      isEditProfileModal,
      setIsUploadVideoModal,
      isUploadVideoModal,
    }),
    [
      setIsModal,
      isModal,
      setIsEditProfileModal,
      isEditProfileModal,
      setIsUploadVideoModal,
      isUploadVideoModal,
    ]
  );
  return (
    <ModalContext.Provider value={memoizedContextValue}>
      {children}
    </ModalContext.Provider>
  );
};

const useModal = () => useContext(ModalContext);

export { ModalProvider, useModal };
